// extracted by mini-css-extract-plugin
module.exports = {"tableCell":"LayeredTableCell_tableCell__1Z0JY","header":"LayeredTableHeader_header__12LM3"};